"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionWizard = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _common = require("../common");
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated Please use SubscriptionWizard from libs instead. */
const SubscriptionWizard = ({
  environment,
  rootAttributes = {}
}) => {
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    globalApiUrl,
    identityUrl,
    kpiApiUrl,
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi', 'identity', 'staticApi']);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_common.Spa, {
    config: (0, _react.useMemo)(() => ({
      currentLanguage: language,
      customerId,
      globalApiUrl,
      identityUrl,
      kpiApiUrl,
      staticApiUrl,
      tenant
    }), [customerId, identityUrl, globalApiUrl, kpiApiUrl, language, staticApiUrl, tenant]),
    environment: environment,
    name: "subscription-wizard"
  });
};
exports.SubscriptionWizard = SubscriptionWizard;
